<template>
    <div class="feedback-modal"  @touchmove.prevent>
      <div class="modal-mask" @touchmove.stop="onModalMaskTouchMove" >
        <div class="feedback-modal-content" >
          <div class="modal-title">
            <label class="close-btn" @click.stop="closeModal"></label>
          </div>
          <div class="iframe-box">
            <iframe :src="iframeUrl" id="iframeId" name="iframeName"  frameborder="0" scrolling="auto" style="height:100%;width: 100%;"></iframe>
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="less" scoped>

</style>

<script>
export default {
  props: ['refs'],
  data () {
    return {
    }
  },
  mixins: [],
  components: {},
  computed: {
    iframeHeight: function () {
      return document.documentElement.clientHeight - 50
    },
    iframeUrl: function () {
      let url = 'https://wallet-io.udesk.cn/im_client/feedback_tab/new.html?form=2';
      return url
    }
  },
  mounted () {
    if (this.refs.iframeShow) {
      var bodyWidth = window.innerWidth - document.body.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = bodyWidth + 'px';
    }
  },
  methods: {
    closeModal () {
      this.refs.iframeShow = false;
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = 0 + 'px';
    },
    onModalMaskTouchMove () {
      console.log('onModalMaskTouchMove')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/feedback_modal.vue